import { getAnalytics, logEvent, setUserId } from 'firebase/analytics';
import { initializeApp } from 'firebase/app';
import values from 'stores/values';
import { EventParams } from 'types/common';
import { CustomerInfoType } from 'types/customer';
import { isProd } from 'utils/API';
import { getTrackEventBaseInfoType, getTrackOpenType } from './helper';
// https://firebase.google.com/docs/web/setup#available-libraries

// firebase的配置信息, 可以直接在firebase的对应应用的设置界面查看对应配置信息, 或者查看文档:https://support.google.com/firebase/answer/7015592?authuser=0&hl=zh-Hans#zippy=%2C%E6%9C%AC%E6%96%87%E5%8C%85%E5%90%AB%E7%9A%84%E4%B8%BB%E9%A2%98
const firebaseConfig = isProd
    ? {
          apiKey: 'AIzaSyBvHZYf3AFJOol2ei5-Y1fMakD1tjsGUes',
          authDomain: 'tradeup-web-eeff4.firebaseapp.com',
          projectId: 'tradeup-web-eeff4',
          storageBucket: 'tradeup-web-eeff4.firebasestorage.app',
          messagingSenderId: '562877923782',
          appId: '1:562877923782:web:63ef281a82b3c1523232c7',
          measurementId: 'G-YMED6WVPX5'
      }
    : {
          apiKey: 'AIzaSyB_NhYLNBKEfpu2gj-8KrOXfUOT5_H9W7U',
          authDomain: 'tradeup-web-dev.firebaseapp.com',
          projectId: 'tradeup-web-dev',
          storageBucket: 'tradeup-web-dev.firebasestorage.app',
          messagingSenderId: '899403519344',
          appId: '1:899403519344:web:23e4cc171245fa32cf2bb5',
          measurementId: 'G-E565DZ920P'
      };

// 初始化firebase
const app = initializeApp(firebaseConfig);
// 创建一个analytics实例
const analytics = getAnalytics(app);

// 存放一些通用的埋点相关的数据等
class Track {
    openType: EventParams['openType'];
    eventBaseInfoType?: string; // 对应埋点字段 param2

    // 如果需要绑定用户id的话, 可以通过setUserId方法来设置用户id: https://firebase.google.com/docs/analytics/userid?hl=zh-cn
    // 无需设置用户 ID 即可让 Analytics 正常运行。如果您只想查找单个设备上同一应用中属于同一用户的事件数据，则可以使用 user_pseudo_id。该值由 Analytics 自动生成，并随每个事件存储在 BigQuery 中。
    // 设置埋点系统中独一无二的用户id, 开户系统中使用uuid来进行标识
    setEventUUId(uuid: number | null) {
        // uuid存在的时候才设置, 不存在的时候不设置, 不设置的时候, firebase会自动生成一个user_pseudo_id
        if (uuid) {
            setUserId(analytics, String(uuid));
        }
    }

    trackEvent(eventParmas: EventParams) {
        const { openType, eventBaseInfoType, model, name } = eventParmas;
        const { id_type, customer_type, has_delivery_address, category } =
            values.getParams<CustomerInfoType | undefined>() || {};

        logEvent(analytics, 'web_open', {
            model,
            name,
            // 这个字段只有在埋点的时候才叫param1, 在开户项目中命名为: openType, 方便区分
            param1: openType || this.openType || getTrackOpenType({ idType: id_type, category }),
            param2:
                eventBaseInfoType ||
                this.eventBaseInfoType ||
                getTrackEventBaseInfoType({
                    idType: id_type,
                    customerType: customer_type,
                    hasDeliveryAddress: has_delivery_address
                })
        });
    }

    // 直接设置开户类型
    setEventOpenType(openType: EventParams['openType']) {
        this.openType = openType;
    }
}

const store = new Track();

export default store;
export * from './hook';
